import { ComponentsManager } from '../core/smpl-components'

import ComponentBody from '../components/body'
import ComponentPageHero from '../components/page-hero'
import ComponentFaqAccordion from '../components/faq-accordion'
import ComponentMainNav from '../components/main-nav'
import ComponentActivitiesList from '../components/activities-list'
import ComponentStatisticsHighlight from '../components/statistics-highlight'
import ComponentScrollParallax from '../components/scroll-parallax'
import ComponentProgramCard from '../components/program-card'
import ComponentPageLogos from '../components/page-logos'
import ComponentVisualTimeline from '../components/visual-timeline'
import ComponentArchiveList from '../components/archive-list'
import ComponentEventsList from '../components/events-list'
import ComponentHeaderPanels from '../components/header-panels'
import ComponentCart from '../components/cart'
import ComponentAddToCart from '../components/add-to-cart'
import ComponentTextExpandable from '../components/text-expandable'
import ComponentAnchorNav from '../components/anchor-nav'
import ComponentProductGallery from '../components/product-gallery'
import ComponentShopFilter from '../components/shop-filter'
import ComponentBookTilt from '../components/book-tilt'
import ComponentBergEyes from '../components/berg-eyes'
import ComponentNewsletter from '../components/newsletter'
import ComponentLogo from '../components/logo'
import ComponentFooter from '../components/footer'
import ComponentTextImages from '../components/text-images'

// Component registry. Each entry maps a CSS selector to a component class,
// lazily loaded. Add new components here. See components/body.js for the
// reference implementation.
const componentRegistry = [
	{
		selector: 'body',
		name: 'body',
		loader: () => ComponentBody,
	},
	{
		selector: '.js-page-hero',
		name: 'page-hero',
		loader: () => ComponentPageHero,
	},
	{
		selector: '.js-faq-accordion',
		name: 'faq-accordion',
		loader: () => ComponentFaqAccordion,
	},
	{
		selector: '.js-main-nav',
		name: 'main-nav',
		loader: () => ComponentMainNav,
	},
	{
		selector: '.js-activities-list',
		name: 'activities-list',
		loader: () => ComponentActivitiesList,
	},
	{
		selector: '.js-statistics-highlight',
		name: 'statistics-highlight',
		loader: () => ComponentStatisticsHighlight,
	},
	{
		// Genuinely code-split: p5 + all sketches live in their own chunk that is
		// only fetched on pages that actually have a .js-gen-visual element.
		selector: '.js-gen-visual',
		name: 'gen-visual',
		loader: () => import('../components/gen-visual'),
	},
	{
		selector: 'body',
		name: 'scroll-parallax',
		loader: () => ComponentScrollParallax,
	},
	{
		selector: '.js-program-card',
		name: 'program-card',
		loader: () => ComponentProgramCard,
	},
	{
		selector: '.js-visual-timeline',
		name: 'visual-timeline',
		loader: () => ComponentVisualTimeline,
	},
	{
		selector: '.js-page-logos',
		name: 'page-logos',
		loader: () => ComponentPageLogos,
	},
	{
		selector: '.js-archive-list',
		name: 'archive-list',
		loader: () => ComponentArchiveList,
	},
	{
		selector: '.js-events-list',
		name: 'events-list',
		loader: () => ComponentEventsList,
	},
	{
		selector: '.js-header-panels',
		name: 'header-panels',
		loader: () => ComponentHeaderPanels,
	},
	{
		selector: '.js-cart',
		name: 'cart',
		loader: () => ComponentCart,
	},
	{
		selector: '.js-add-to-cart',
		name: 'add-to-cart',
		loader: () => ComponentAddToCart,
	},
	{
		selector: '.js-product-gallery',
		name: 'product-gallery',
		loader: () => ComponentProductGallery,
	},
	{
		selector: '.js-shop-filter',
		name: 'shop-filter',
		loader: () => ComponentShopFilter,
	},
	{
		selector: '.js-book-tilt',
		name: 'book-tilt',
		loader: () => ComponentBookTilt,
	},
	{
		selector: '.js-text-expandable',
		name: 'text-expandable',
		loader: () => ComponentTextExpandable,
	},
	{
		selector: '.js-anchor-nav',
		name: 'anchor-nav',
		loader: () => ComponentAnchorNav,
	},
	{
		selector: '.js-berg-eyes',
		name: 'berg-eyes',
		loader: () => ComponentBergEyes,
	},
	{
		selector: '.js-newsletter',
		name: 'newsletter',
		loader: () => ComponentNewsletter,
	},
	{
		selector: '.js-logo',
		name: 'logo',
		loader: () => ComponentLogo,
	},
	{
		selector: '.js-footer',
		name: 'footer',
		loader: () => ComponentFooter,
	},
	{
		selector: '.js-text-images',
		name: 'text-images',
		loader: () => ComponentTextImages,
	},
]

export const initComponents = (ctx) => {
	ComponentsManager.setup({
		debug: true,
		components: componentRegistry,
		eventBus: ctx.eventBus,
	})

	ctx.componentsManager = ComponentsManager

	return ComponentsManager
}
